import React, { useMemo } from 'react'
import { Tabs, Button, Form } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { getTabItems } from '../utils/getTabITems'

const TabsHeader = ({
  activeTab,
  onTabChange,
  isAddingTemplate,
  isSubmitting,
  onCancel,
  onSubmit,
  token,
  getUnfilledCount,
  newTemplateName,
  selectedDataPoints,
  form
}) => {
  // Watch all form fields for changes
  const formValues = Form.useWatch([], form)
  
  // Check if any form values are filled
  const hasFormValues = useMemo(() => {
    if (!formValues) return false
    
    // Check if there are any non-empty values in the form
    return Object.values(formValues || {}).some(value => {
      if (value === undefined || value === null || value === '') return false
      if (typeof value === 'object' && Object.keys(value).length === 0) return false
      return true
    })
  }, [formValues])

  const tabItems = useMemo(
    () =>
      getTabItems({
        token,
        getUnfilledCount: (category) => getUnfilledCount(category, selectedDataPoints, form),
        isAddingTemplate
      }),
    // eslint-disable-next-line
    [token, getUnfilledCount, isAddingTemplate, selectedDataPoints, formValues] // Use formValues instead of form.getFieldsValue()
  )

  return (
    <Tabs
      style={{ marginTop: 48 }}
      defaultActiveKey='templates'
      items={tabItems}
      activeKey={activeTab}
      onChange={onTabChange}
      tabBarExtraContent={{
        left: (
          <Button onClick={onCancel} disabled={isSubmitting} style={{ marginRight: 12 }}>
            <FontAwesomeIcon icon={faXmark} color={token.colorBorder} /> {isAddingTemplate ? 'Cancel' : 'Close'}
          </Button>
        ),
        right: (
          <Button
            onClick={onSubmit}
            loading={isSubmitting}
            style={{ 
              background: hasFormValues ? token.colorSuccess : undefined, 
              marginLeft: 12 
            }}
            disabled={
              isAddingTemplate ? !newTemplateName || selectedDataPoints.length === 0 : selectedDataPoints.length === 0
            }
            type={hasFormValues ? 'primary' : 'default'}
          >
            {isAddingTemplate ? 'Save Template' : 'Submit Readings'}
          </Button>
        )
      }}
    />
  )
}

export default TabsHeader
